export const isEmptyObject = (o: object) => {
  return Object.keys(o).length === 0;
};
